import { values } from "lodash";
import { decodeHTML } from "~/Utils/CommonUtils";
import { ModuleConfig, ModuleFields } from "~/Utils/drilldownData";

export const getAnnouncementsDrillDownData: { [key in ModuleConfig]: ModuleFields[] } = {
  general: [
    {
        fieldName: "Title (EN)",
        fieldValue: "field_title_general_en",
        className: "col-span-6",
        type: "text",
        name: "field_title_general_en",
        formType: "input",
        label: "Title (EN)",
        placeholder: "Enter Title (EN)",
        validation: { required: "Title (EN) is required" },
    },
    {
        fieldName: "Title (MS)",
        fieldValue: "field_title_general_ms",
        className: "col-span-6",
        type: "text",
        name: "field_title_general_ms",
        formType: "input",
        label: "Title (MS)",
        placeholder: "Enter Title (MS)",
        // validation: { required: "Title (MS) is required" },
    },
    {
        fieldName: "Title (ZH)",
        fieldValue: "field_title_general_zh",
        className: "col-span-6",
        type: "text",
        name: "field_title_general_zh",
        formType: "input",
        label: "Title (ZH)",
        placeholder: "Enter Title (ZH)",
        // validation: { required: "Title (ZH) is required" },
    },
    {
      fieldName: "General Date",
      fieldValue: "field_circular_date",
      className: "col-span-6",
      type: "date",
      name: "field_circular_date",
      formType: "date",
      label: "General Date",
      placeholder: "Select General Date",
      validation: { required: "General Date is required" },
    },
    {
        fieldName: "Description (EN)",
        fieldValue: "field_description_general_en",
        className: "col-span-6",
        type: "text",
        name: "field_description_general_en",
        formType: "richText",
        label: "Description (EN)",
        placeholder: "Enter Description (EN)",
        validation: { required: "Description (EN) is required"  },
    },
    {
        fieldName: "Description (MS)",
        fieldValue: "field_description_general_ms",
        className: "col-span-6",
        type: "text",
        name: "field_description_general_ms",
        formType: "richText",
        label: "Description (MS)",
        placeholder: "Enter Description (MS)",
        // validation: { required: "Procurement Text (MS) is required" },
    },
    {
        fieldName: "Description (ZH)",
        fieldValue: "field_general_description_zh",
        className: "col-span-6",
        type: "text",
        name: "field_general_description_zh",
        formType: "richText",
        label: "Description (ZH)",
        placeholder: "Enter Description (ZH)",
        // validation: { required: "Procurement Text (ZH) is required" },
    },
    {
      fieldName: "Published",
      fieldValue: "field_page_published_circular",
      className: "col-span-12",
      type: "checkbox",
      name: "field_page_published_circular",
      formType: "checkbox",
      label: "Published",
      placeholder: "Published",
    },
  ],
  circular: [
    {
      fieldName: "Title (EN)",
      fieldValue: "field_title_eng",
      className: "col-span-6",
      type: "text",
      name: "field_title_eng",
      formType: "input",
      label: "Title (EN)",
      placeholder: "Enter Title (EN)",
      validation: { required: "Title (EN) is required" },
    },
    {
      fieldName: "Title (MS)",
      fieldValue: "field_title_mal",
      className: "col-span-6",
      type: "text",
      name: "field_title_mal",
      formType: "input",
      label: "Title (MS)",
      placeholder: "Enter Title (MS)",
      // validation: { required: "Title (MS) is required" },
    },
    {
      fieldName: "Title (ZH)",
      fieldValue: "field_title_man",
      className: "col-span-6",
      type: "text",
      name: "field_title_man",
      formType: "input",
      label: "Title (ZH)",
      placeholder: "Enter Title (ZH)",
      // validation: { required: "Title (ZH) is required" },
    },
    {
      fieldName: "PDF",
      fieldValue: "field_pdfurl",
      className: "col-span-6",
      type: "pdf",
      name: "field_pdfurl",
      formType: "file",
      label: "PDF",
      usedFileType: '.pdf',
      placeholder: "Upload PDF",
      validation: { required: "PDF is required" },
    },
    {
      fieldName: "Circular Date",
      fieldValue: "field_date",
      className: "col-span-6",
      type: "date",
      name: "field_date",
      formType: "date",
      label: "Circular Date",
      placeholder: "Enter Circular Date",
      validation: { required: "Circular Date is required" },
    },
    {
      fieldName: "Description (EN)",
      fieldValue: "field_description_eng",
      className: "col-span-6",
      type: "text",
      name: "field_description_eng",
      formType: "richText",
      label: "Description (EN)",
      placeholder: "Enter Description (EN)",
      validation: { 
        validate: (value: string) => {
          const removeHtmlTags = (input: string) => {
            const doc = new DOMParser().parseFromString(input, "text/html");
            return doc.body.textContent || "";
          };
          const decodedValue = decodeHTML(value);
          const cleanedValue = removeHtmlTags(decodedValue);      
          return cleanedValue.length <= 150 || "Description (EN) must be at most 150 characters";
        },        
        // maxLength: 150,
      },
      note: "Description (EN) must not exceed 150 characters"     
  },
  {
      fieldName: "Description (MS)",
      fieldValue: "field_description_mal",
      className: "col-span-6",
      type: "text",
      name: "field_description_mal",
      formType: "richText",
      label: "Description (MS)",
      placeholder: "Enter Description (MS)",
      // validation: { required: "Procurement Text (MS) is required" },
      validation: { 
        validate: (value: string) => {
          const removeHtmlTags = (input: string) => {
            const doc = new DOMParser().parseFromString(input, "text/html");
            return doc.body.textContent || "";
          };
          const decodedValue = decodeHTML(value);
          const cleanedValue = removeHtmlTags(decodedValue);      
          return cleanedValue.length <= 150 || "Description (EN) must be at most 150 characters";
        },        
        // maxLength: 150,
      },
      note: "Description (MS) must not exceed 150 characters"     
 
  },
  {
      fieldName: "Description (ZH)",
      fieldValue: "field_description_man",
      className: "col-span-6",
      type: "text",
      name: "field_description_man",
      formType: "richText",
      label: "Description (ZH)",
      placeholder: "Enter Description (ZH)",
      // validation: { required: "Procurement Text (ZH) is required" },
      validation: { 
        validate: (value: string) => {
          const removeHtmlTags = (input: string) => {
            const doc = new DOMParser().parseFromString(input, "text/html");
            return doc.body.textContent || "";
          };
          const decodedValue = decodeHTML(value);
          const cleanedValue = removeHtmlTags(decodedValue);      
          return cleanedValue.length <= 150 || "Description (EN) must be at most 150 characters";
        },        
        // maxLength: 150,
      },
      note: "Description (ZH) must not exceed 150 characters"     
    
  },
    {
      fieldName: "Published",
      fieldValue: "field_circular_published",
      className: "col-span-12",
      type: "checkbox",
      name: "field_circular_published",
      formType: "checkbox",
      label: "Published",
      placeholder: "Published",
    },
  ],
};